import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const schoolStudentList = createAsyncThunk(
  'school/student-list',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-student/list`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const schoolStudentATAList = createAsyncThunk(
  'school/student-ata-list',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-student/ata-list`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const changeStudentStatus = createAsyncThunk(
  'change-student-status',
  async ({id, type}: {type: string; id: string}, thunkAPI) => {
    try {
      await axios.get(`${api}school-student/change-student-status/${id}/${type}`)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const studentScores = createAsyncThunk('scores', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-student/scores/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response?.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getEducationDegrees = createAsyncThunk(
  'school/get-education-degrees',
  async (_, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-student/get-education-degrees`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const getClassRooms = createAsyncThunk(
  'school/get-class-rooms',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-student/get-class-rooms/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const ClassRooms = createAsyncThunk('class-rooms', async (id: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}school-student/class-rooms/${id}`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const schoolStudentStore = createAsyncThunk(
  'school/student-store',
  async (studentData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}school-student/store`, studentData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const transferStore = createAsyncThunk(
  'school/transfer-store',
  async (studentData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}school-student/transfer-store`, studentData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const schoolStudentEdit = createAsyncThunk(
  'school/student-edit',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-student/edit/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const schoolStudentView = createAsyncThunk(
  'school/student-view',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-student/view/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const getStudentRelatives = createAsyncThunk(
  'school/get-student-relatives',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-student/get-student-relatives/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const studentRelativeStore = createAsyncThunk(
  'school/student-relative-store',
  async (stdRelativeData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(
        `${api}school-student/store-student-relative`,
        stdRelativeData
      )
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const studentRelativeEdit = createAsyncThunk(
  'school/student-relative-edit',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-student/edit-student-relative/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const studentRelativeDelete = createAsyncThunk(
  'school/student-relative-delete',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-student/delete-student-relative/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const getClassTransportFee = createAsyncThunk(
  'school/get-class-rooms',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}school-student/get-class-transport-fee`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const ListStudentUpgrade = createAsyncThunk(
  'student-list-for-upgrade',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student/list-upgrade`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentClassUpgradeList = createAsyncThunk(
  'student-class-upgrade',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student/list-upgrade`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentClassUpgrade = createAsyncThunk(
  'student-class-upgrade',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student/class-upgrade`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getStudentTransports = createAsyncThunk(
  'school/get-student-transports',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-student/get-student-transports/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const TransportStore = createAsyncThunk('transport-store', async (dat: any, thunkAPI) => {
  try {
    const {data} = await axios.post(`${api}school-student/store-student-transport`, dat)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data)
  }
})

export const studentTransportEdit = createAsyncThunk(
  'school/student-transport-edit',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-student/edit-student-transport/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const studentTransportChangeStatus = createAsyncThunk(
  'school/student-transport-change-status',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-student/change-status-student-transport/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const StudentCardPrint = createAsyncThunk('std-card-print', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-student/print-card/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const SubjectGradeSheetExcel = createAsyncThunk(
  'subject-grade-sheet',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student/subject-grade-sheet-excel`, data, {
        responseType: 'blob',
      })

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'Subject Grade Sheet.xlsx')
      document.body.appendChild(link)
      link.click()
      link.remove()
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const ImportExcelStd = createAsyncThunk('import-stds', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}school-student/upload-students`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentStatistics = createAsyncThunk('statistics', async (_, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}school-student/statistics`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const PrintStudents = createAsyncThunk('print-students', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-student/print-students`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentExcel = createAsyncThunk('student-excel', async (params: {}) => {
  const response = await axios.get(`${api}school-student/excel-students`, {
    params,
    responseType: 'blob',
  })

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })

  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = 'Student List.xlsx'
  document.body.appendChild(link)
  link.click()

  link.remove()
  window.URL.revokeObjectURL(url)
})

export const UploadSchoolStudentPhoto = createAsyncThunk(
  'upload-photo',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student/upload-photo`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getScholarshipStudentReport = createAsyncThunk(
  'get-scholarship-student-report',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student/get-scholarship-student-report`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const printScholarshipStudentReport = createAsyncThunk(
  'print-student-fees-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student/print-scholarship-student-report`, {
        params,
      })

      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const scholarshipStudentExcelReport = createAsyncThunk(
  'student-fees-excel-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student/scholarship-student-excel-report`, {
        params,
        responseType: 'blob',
      })
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const StudentDocumentList = createAsyncThunk(
  'student-document-list',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student-document/list/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StoreDocument = createAsyncThunk(
  'student-document-store',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student-document/store`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const DeleteDocument = createAsyncThunk(
  'student-document-destroy',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student-document/destroy/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const DownloadDocument = createAsyncThunk(
  'documents/download',
  async (id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student-document/download/${id}`, {
        responseType: 'blob',
      })
      return response
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetStudentClasses = createAsyncThunk(
  'student-classes',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student/get-student-classes/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentClasses = createAsyncThunk('std-classes', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-student/student-classes/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetStudentAttendance = createAsyncThunk(
  'student-attendance',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student/get-student-attendance`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getFailStudents = createAsyncThunk('get-fail-students', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-student/get-fail-students`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentFailClass = createAsyncThunk('get-fail-students', async (id: any, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-student/get-students-fail-class/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetProgressClassRoom = createAsyncThunk(
  'get-progress-class-rooms',
  async (id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student/get-progress-class-rooms/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const FailStudentChangeClass = createAsyncThunk(
  'fail-student-change-class',
  async (data: any, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student/fail-student-change-class`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetStudentsForArchive = createAsyncThunk(
  'get-students-for-archive',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student/get-students-for-archive`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ArchiveStudents = createAsyncThunk(
  'archive-students',
  async (formData: FormData, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student/archive-students`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StdClases = createAsyncThunk('stdClasses', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-student/std-classes/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response?.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StoreScholarship = createAsyncThunk(
  'store-scholarship',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student/store-scholarship`, data)
      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetStudentByClassRoom = createAsyncThunk('get-students', async (id: any, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-student/get-students-by-class-room/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PrintStudentResultPaper = createAsyncThunk(
  'print-student-result-paper',
  async (data: any, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student/print-student-result-paper`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentAlumniList = createAsyncThunk(
  'get-student-alumni-list',
  async (data: any, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student/get-student-alumni-list`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentAlumniStore = createAsyncThunk(
  'get-student-alumni-store',
  async (data: any, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student/get-student-alumni-store`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type SchoolStudentState = {
  errors: any
}

const initialState: SchoolStudentState = {
  errors: '',
}

export const schoolStudentSlice = createSlice({
  name: 'school-student',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(schoolStudentStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(studentRelativeStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })

    builder.addCase(transferStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = schoolStudentSlice.actions
export default schoolStudentSlice.reducer
